import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const paginationLoadMoreRecipe = defineSlotRecipe({
  className: 'pagination-load-more',
  slots: ['root', 'counter', 'error'],
  base: {
    root: {
      alignItems: 'center',
      display: 'flex',
      paddingBlock: '8',
      paddingInline: '16',
    },
    counter: {
      color: 'text/secondary',
      fontVariantNumeric: 'tabular-nums',
      '&:has(+ *)': {
        borderInlineEndColor: 'border/regular',
        borderInlineEndStyle: 'solid',
        borderInlineEndWidth: '1',
      },
    },
    error: {
      alignItems: 'center',
      color: 'text/negative',
      display: 'flex',
      flex: '1',
      gap: '4',
      justifyContent: 'flex-end',
      minWidth: 0,
      paddingBlock: '2',
    },
  },
  variants: {
    // md/sm keep a wider gap than the Figma spec (24/16 instead of 12/8). Figma expects the
    // tertiary button's own inline padding to make up the rest, but that puts its hover
    // background within 12/8px of the divider. Trading exact spec for hover breathing room.
    size: {
      md: {
        root: {
          gap: '24',
          minHeight: rem(56),
        },
        counter: {
          textStyle: 'body/md/regular',
          '&:has(+ *)': {
            paddingInlineEnd: '24',
          },
        },
        error: {
          textStyle: 'body/md/regular',
        },
      },
      sm: {
        root: {
          gap: '16',
          minHeight: '48',
        },
        counter: {
          textStyle: 'body/md/regular',
          '&:has(+ *)': {
            paddingInlineEnd: '16',
          },
        },
        error: {
          textStyle: 'body/md/regular',
        },
      },
      xs: {
        root: {
          gap: '12',
          minHeight: '32',
        },
        counter: {
          textStyle: 'body/sm/regular',
          '&:has(+ *)': {
            paddingInlineEnd: '12',
          },
        },
        error: {
          textStyle: 'body/sm/regular',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default paginationLoadMoreRecipe;
